const passkey_sign_in = {
    setup_page: {
        title: 'بسّط عملية تسجيل الدخول',
        subtitle: 'أنشئ مفتاح مرور',
        description: 'سجّل مفتاح المرور باستخدام القياسات الحيوية للجهاز، أو مفاتيح الأمان مثل YubiKey، أو أي طرق متاحة أخرى.',
    },
    trigger_conditional_ui_failed: 'فشل تشغيل التعبئة التلقائية بمفتاح المرور.',
};
export default Object.freeze(passkey_sign_in);
